import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'custom-input-number-control',
  templateUrl: './custom-input-number-control.component.html',
  styleUrls: ['./custom-input-number-control.component.css']
})
export class CustomInputNumberControlComponent implements OnChanges {
  ngOnChanges(changes: SimpleChanges): void {
    if(this.stock){
      if(this.stock < this.ngValue){
          this.ngValue = this.stock
      }
    }

  }
  value?: any;

  @Input() styleProperties: string = '';
  @Input() disabled: boolean = false;
  @Input() stock?: number;
  @Input() mediumSizeFlexColumButton: boolean = false;

  @Input()
  set ngValue(value: any){
    this.value = value;
  }

  @Output()
  ngValueChange = new EventEmitter<any>();

  get ngValue() {
    return this.value;
  }

  event(operation: string){
    if(this.stock){
      if(operation == '+') {
        if(this.stock > this.ngValue){
          this.ngValue++;
          this.ngValueChange.emit(this.value);
        }
        return
      }
      else if(this.ngValue > 1){
        this.ngValue--;
        this.ngValueChange.emit(this.value);
      }
    }
  }


}
